import styled from '@emotion/styled';
import { Flex } from '@linearb/linui-common';
import { Button } from '@mui/material';
import LoginBackgroundContainer from './LoginBackground/LoginBackground.style';
import StyledLoginModal from './LoginModal/LoginModal.style';

export const LoginContainer = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;

  ${LoginBackgroundContainer} {
    position: absolute;
    right: -3rem;
  }

  ${StyledLoginModal} {
    width: 47rem;
    height: 57rem;
    position: absolute;
    z-index: 11;
  }
`;

export const LearnMoreButton = styled(Button)`
  padding: 0.4rem 0.8rem;
  text-transform: capitalize;
  font-size: 1rem;
  border-radius: 0.4rem;
`;
